import { Button, ButtonLink } from '@teo/components';
import { ArrowLeft } from '@teo/components/icons';
import { useTranslation } from 'react-i18next';
import { NotificationButton } from '@/components/Notifications/NotificationButton';
import { nthLastIndexOf } from '@/util';
import { useNavigate } from 'react-router-dom';

const MobileSubPageMenu = ({ title, lastPath, to, backFn }: any) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const prevPath = window.location.pathname.slice(
    0,
    nthLastIndexOf(window.location.pathname, '/', 1)
  );

  return (
    <div className="mt-2 flex w-full items-center justify-between pb-6">
      <div>
        {(prevPath || backFn) && !to && (
          <Button
            variant="ghost"
            className="!px-2"
            onClick={() =>
              backFn
                ? backFn()
                : navigate(`${lastPath ? prevPath + '/' + lastPath : prevPath}`)
            }
          >
            <ArrowLeft className="h-6 w-6 text-grey-07" />
          </Button>
        )}
        {to && (
          <ButtonLink to={to} variant="ghost" className="!px-2">
            <ArrowLeft className="h-6 w-6 text-grey-07" />
          </ButtonLink>
        )}
      </div>
      {title && (
        <h1 className="text-xl font-semibold text-black">{t(title)}</h1>
      )}
      <NotificationButton />
    </div>
  );
};
export default MobileSubPageMenu;
